import { get, handleApiError } from '@helpers/httpClient';
export interface IGeoRegionDTO {
  id: string;
  name: string;
  id_country: string;
  country_name: string;
  my: string;
}
export interface IGeoRegion {
  id: number;
  name: string;
  id_country: number;
  country_name: string;
}

export const getGeoRegionsAsync = async (q = '%25'): Promise<IGeoRegion[]> => {
  const data = await get<IGeoRegionDTO[]>(`/ajax/geo_regions.php?q=${q}`);
  return data.map((d) => {
    return {
      id: +d.id,
      name: d.name,
      id_country: +d.id_country,
      country_name: d.country_name,
    };
  });
};

export const getCurrentGeoInformation = () => {
  return get('/ajax/auto_geo.php').then<{ id: string; name: string; name_r: string }>(
    handleApiError,
  );
};
